const YEARS_IN_PAST = 100;
const YEARS_IN_FUTURE = 10;
const DAYS_IN_YEAR = 365.25; // we add/substract days based on years including leap years

export const DEFAULT_AVAILABLE_DAYS_RANGE = {
  after: DAYS_IN_YEAR * YEARS_IN_PAST,
  before: DAYS_IN_YEAR * YEARS_IN_FUTURE,
};
